import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PousadaMasteryLanding from './components/PousadaMasteryLanding';
import { BiigApp } from './components/BiigApp';
import { ArchitectureDiagram } from './components/ArchitectureDiagram';
import { ProjectStructure } from './components/ProjectStructure';
import FlywheelDashboard from './components/flywheel/FlywheelDashboard';
import Phase0Tester from './components/flywheel/Phase0Tester';
import Phase1Infrastructure from './components/phase/Phase1Infrastructure';
import HiddenGemsDashboard from './components/hidden-gems/HiddenGemsDashboard';
import RedditScraperDashboard from './components/scraper/RedditScraperDashboard';
import PousadaKnolling from './components/pousada/PousadaKnolling';
import PousadaOperations from './components/pousada/PousadaOperations';
import PousadaMobile from './components/pousada/PousadaMobile';
import PousadaMobileAI from './components/pousada/PousadaMobileAI';
import AdapterManager from './components/adapters/AdapterManager';
import MobileMastery from './components/mastery/MobileMastery';
import OperatorMastery from './components/mastery/OperatorMastery';
import InRoomExperience from './components/mastery/InRoomExperience';
import UnifiedMastery from './components/mastery/UnifiedMastery';
import IntegrationForge from './components/forge/IntegrationForge';
import WhatsAppSender from './components/WhatsAppSender';
import DevDashboard from './components/DevDashboard';
import MethodicalSetup from './components/MethodicalSetup';
import WhatsAppSetupTool from './components/WhatsAppSetupTool';
import TelegramSetupTool from './components/TelegramSetupTool';
import TelegramBusinessDashboard from './components/TelegramBusinessDashboard';
import TelegramExecutiveDashboard from './components/TelegramExecutiveDashboard';
import LocationPulse from './components/LocationPulse';
import LocationPulseDiagnostic from './components/LocationPulseDiagnostic';
import GlobalActivityMap from './components/GlobalActivityMap';
import ModerationDashboard from './components/ModerationDashboard';
import WorkButtonsApp from './components/work-buttons/WorkButtonsApp';
import ProblemExplorer from './components/ProblemExplorer';
import SingleQuestionExperience from './components/SingleQuestionExperience';
import ProblemQuestionLinks from './components/ProblemQuestionLinks';
import ProjectsDirectory from './components/ProjectsDirectory';
import BiigLinks from './components/BiigLinks';
import CTODashboard from './components/CTODashboard';
import ColorPalettes from './components/ColorPalettes';
import ResearchLinks from './components/ResearchLinks';
import AIConnectionTest from './components/AIConnectionTest';

function App() {
  return (
    <Routes>
      <Route path="/" element={<PousadaMasteryLanding />} />
      <Route path="/projects" element={<ProjectsDirectory />} />
      <Route path="/biig-links" element={<BiigLinks />} />
      <Route path="/cto/*" element={<CTODashboard />} />
      <Route path="/colors" element={<ColorPalettes />} />
      <Route path="/research" element={<ResearchLinks />} />
      <Route path="/ai-connection-test" element={<AIConnectionTest />} />
      <Route path="/biig" element={<BiigApp />} />
      <Route path="/architecture" element={<ArchitectureDiagram />} />
      <Route path="/structure" element={<ProjectStructure />} />
      <Route path="/flywheel" element={<FlywheelDashboard />} />
      <Route path="/phase0" element={<Phase0Tester />} />
      <Route path="/phase1" element={<Phase1Infrastructure />} />
      <Route path="/hidden-gems" element={<HiddenGemsDashboard />} />
      <Route path="/scraper" element={<RedditScraperDashboard />} />
      <Route path="/pousada" element={<PousadaKnolling />} />
      <Route path="/pousada-ops" element={<PousadaOperations />} />
      <Route path="/pousada-mobile" element={<PousadaMobile />} />
      <Route path="/pousada-ai" element={<PousadaMobileAI />} />
      <Route path="/adapters" element={<AdapterManager />} />
      <Route path="/mastery" element={<MobileMastery />} />
      <Route path="/operator-mastery" element={<OperatorMastery />} />
      <Route path="/room" element={<InRoomExperience />} />
      <Route path="/unified" element={<UnifiedMastery />} />
      <Route path="/forge" element={<IntegrationForge />} />
      <Route path="/whatsapp" element={<WhatsAppSender />} />
      <Route path="/dev" element={<DevDashboard />} />
      <Route path="/setup" element={<MethodicalSetup />} />
      <Route path="/whatsapp-tool" element={<WhatsAppSetupTool />} />
      <Route path="/telegram-tool" element={<TelegramSetupTool />} />
      <Route path="/telegram-business" element={<TelegramBusinessDashboard />} />
      <Route path="/executive" element={<TelegramExecutiveDashboard />} />
      {/* Location Pulse Routes - Main app */}
      <Route path="/share" element={<LocationPulse />} />
      <Route path="/global" element={<GlobalActivityMap />} />
      <Route path="/moderate" element={<ModerationDashboard />} />
      
      {/* Problem Explorer - Problem tracking and management */}
      <Route path="/problems" element={<ProblemExplorer />} />
      <Route path="/problem/:identifier" element={<SingleQuestionExperience />} />
      <Route path="/questions" element={<ProblemQuestionLinks />} />
      
      {/* WorkButtons - One-click workplace automation */}
      <Route path="/work" element={<WorkButtonsApp />} />
      <Route path="/workbuttons" element={<WorkButtonsApp />} />
      
      {/* Legacy routes for backwards compatibility */}
      <Route path="/location" element={<LocationPulse />} />
      <Route path="/location-pulse" element={<LocationPulse />} />
      <Route path="/location-diagnostic" element={<LocationPulseDiagnostic />} />
      <Route path="/location-pulse-diagnostic" element={<LocationPulseDiagnostic />} />
    </Routes>
  );
}

export default App;
